import { WishlistFiltrationGroupType } from 'packages/shared/definitions/types';

import { dispatchTrackingEvent } from '@context/tracking/utils';
import { isDesktop } from '@utils/helpers';

export const trackRefresh = (timing: number) => {
  dispatchTrackingEvent({
    event: 'element_click',
    element: {
      timing,
      name: 'filters',
      type: 'filtration',
      interaction: 'button_restore',
      action: 'restore_filtration',
    },
    _clear: true,
  });
};

interface TrackCheckboxFiltrationArgs {
  timing: number;
  action: 'filtration_used' | 'filtration_removed';
  section: string;
  name: string;
  type: WishlistFiltrationGroupType;
}

export const trackCheckboxFiltration = ({
  action,
  timing,
  section,
  name,
  type,
}: TrackCheckboxFiltrationArgs) => {
  const isFiltrationUsed = action === 'filtration_used';
  const interaction = isFiltrationUsed ? 'click_add' : 'click_remove';

  dispatchTrackingEvent({
    event: 'filtration_click',
    filtration: {
      type,
      name,
      section,
      interaction,
      timing,
      action,
      variant: isDesktop() ? 'desktop' : 'mobile',
      path_query: '',
    },
    _clear: true,
  });
};

export const trackSelectFiltration = (timing: number, name: string) => {
  dispatchTrackingEvent({
    event: 'filtration_click',
    filtration: {
      interaction: 'click_drawer_open',
      action: 'filtration_drawer_opened',
      variant: isDesktop() ? 'desktop' : 'mobile',
      name,
      timing,
    },
    _clear: true,
  });
};

export const trackRemoveFiltration = (timing: number, name: string) => {
  dispatchTrackingEvent({
    event: 'filtration_click',
    filtration: {
      interaction: 'button_filter_remove',
      action: 'filtration_filter_removed',
      variant: isDesktop() ? 'desktop' : 'mobile',
      name,
      timing,
    },
    _clear: true,
  });
};

interface TrackApplyFiltrationArgs {
  timing: number;
  filters: number[];
  name: string;
  type: WishlistFiltrationGroupType;
}

export const trackApplyFiltration = ({
  name,
  timing,
  type,
  filters,
}: TrackApplyFiltrationArgs) => {
  dispatchTrackingEvent({
    event: 'filtration_click',
    filtration: {
      interaction: 'filtration_view',
      action: 'filtration_confirmed',
      variant: isDesktop() ? 'desktop' : 'mobile',
      name,
      timing,
      type,
      filters,
    },
    _clear: true,
  });
};

export const trackCategorySelect = ({
  name,
  timing,
  filters,
}: Omit<TrackApplyFiltrationArgs, 'type'>) => {
  dispatchTrackingEvent({
    event: 'navigation_click',
    navigation: {
      interaction: 'click',
      action: 'click',
      variant: isDesktop() ? 'desktop' : 'mobile',
      path_query: '',
      type: 'navigation',
      name,
      timing,
      filters,
    },
    _clear: true,
  });
};
